class SwiperSlider extends HTMLElement {
  constructor() {
    super();
    this.slideContainer = this.querySelector(".swiper");
    this.slides = this.querySelectorAll(".swiper-slide");
    this.sliderOptions = this.applyDefaultOptions(this.getSliderOptions());
    this.activeIndex = 0;
    this.initialized = false;
    if (this.slideContainer && this.slides.length > 0) {
      document.addEventListener(
        "DOMContentLoaded",
        this.initializeSwiper.bind(this)
      );
      document.addEventListener(
        "shopify:section:load",
        this.initializeSwiper.bind(this)
      );
      window.addEventListener("resize", this.handleResize.bind(this));
    } else {
      console.warn("SwiperSlider - Slider or Slides Not Found");
    }
  }

  applyDefaultOptions(options) {
    console.log(options);
    if (options.loop === undefined) {
      options.loop = true;
    }
    options.speed = 400;
    return options;
  }

  getSliderOptions() {
    try {
      return JSON.parse(this.dataset.swiperOptions);
    } catch (err) {
      console.log(err);
      return {};
    }
  }

  initializeSwiper() {
    if (window.Swiper && !this.initialized) {
      this.initialized = true;
      this.slider = new Swiper(this.slideContainer, this.sliderOptions);
      this.initializeSliderEventListeners();
    } else if (!window.Swiper) {
      console.warn("SwiperSlider - Swiper.js not found");
    }
  }

  handleResize(e) {
    if (this.slider) {
      setTimeout(() => {
        this.slider.updateSize();
      }, 300);
    }
  }
  initializeSliderEventListeners() {}
}
customElements.define("swiper-slider", SwiperSlider);

class SwiperTabSlider extends SwiperSlider {
  constructor() {
    super();
    this.tabs = this.querySelectorAll(".glide__nav-item");
    if (this.tabs.length > 0) {
      this.tabs.forEach((tab) => {
        tab.addEventListener("click", this.goToSlide.bind(this, tab));
      });
    }
  }
  goToSlide(tab) {
    try {
      const tabIndex = tab.dataset.newIndex;
      if (tabIndex) {
        this.slider.slideTo(tabIndex);
      } else {
        console.warn("newIndex not provided for Tab Slider Tab");
      }
    } catch (err) {
      console.warn(err);
    }
  }
}
customElements.define("swiper-tab-slider", SwiperTabSlider);

class SwiperFeaturedReviewSlider extends SwiperSlider {
  constructor() {
    super();
  }
  initializeSliderEventListeners() {
    this.slider.on("activeIndexChange", () => {
      const currentIndex = this.slider.activeIndex;
      if (currentIndex > this.slides.length) {
        this.activeIndex = 0;
      } else if (currentIndex < 0) {
        this.activeIndex = this.slides.length - 1;
      } else {
        this.activeIndex = currentIndex - 1;
      }
      this.updateFeaturedReviewMeta();
    });
  }
  updateFeaturedReviewMeta() {
    const activeSlide = this.slides[this.activeIndex];
    const reviewMeta = activeSlide.querySelector(".review-meta");
    const imageContainer = document.getElementById("featured-review_image");
    const titleContainer = document.getElementById("featured-review_title");
    if (reviewMeta) {
      const data = JSON.parse(reviewMeta.textContent);
      if (imageContainer && data) {
        if (data.imageUrl != undefined) {
          imageContainer.setAttribute("src", data.imageUrl);
        }
        if (data.imageAlt != undefined) {
          imageContainer.setAttribute("alt", data.imageAlt);
        }
        if (data.imageWidth != undefined) {
          imageContainer.setAttribute("width", data.imageWidth);
        }
        if (data.imageHeight != undefined) {
          imageContainer.setAttribute("height", data.imageHeight);
        }
        if (data.imageSrcSet != undefined) {
          imageContainer.setAttribute("srcset", data.imageSrcSet);
        }
      }
      if (titleContainer) {
        if (data.productTitle != undefined) {
          titleContainer.innerHTML = data.productTitle;
        }
      }
    }
  }
}

customElements.define(
  "swiper-featured-review-slider",
  SwiperFeaturedReviewSlider
);
